import { createDialog } from '@patsnap/tahiti-core';

export function createRequestFeedbackService() {
    return createDialog(() => import('./FeedbackDialog.vue'));
}
